import { defineMessages } from "react-intl";

export const PALLET_TRACKING_SCAN_ERROR = defineMessages({
  title: {
    id: "crossdock.palletTrackingScanError.title",
    defaultMessage: "Error during scan",
  },
});
